import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AsyncAppThunk } from "store/application-state";
import { showLoaderWhile } from "./ui";

import {
  getProductItemByBarcodeService,
  getProductItemTransactionByBarcodeService,
} from "services/crosspay-service";
import { TransactionsData } from "libs/models/transaction";
import { PaginatedList } from "libs/models/paginated-list";
import { getFilterQuery } from "utils/filter";
import { Filter } from "libs/models/filter";
import { ProductItemModel } from "libs/models/batch-model";

export interface ProductItemStore {
  productItemDetails: ProductItemModel;
  productTransaction: PaginatedList<TransactionsData>;
}

const initialState: ProductItemStore = {
  productItemDetails: {} as ProductItemModel,
  productTransaction: { list: [], pageIndex: 0, pageSize: 10, totalCount: 0 },
};

const slice = createSlice({
  name: "productitem",
  initialState,
  reducers: {
    setProductItemDetailsData: (
      state: ProductItemStore,
      action: PayloadAction<ProductItemModel>
    ) => {
      state.productItemDetails = action.payload;
    },
    setProductItemTransactionData: (
      state: ProductItemStore,
      action: PayloadAction<PaginatedList<TransactionsData>>
    ) => {
      state.productTransaction = action.payload;
    },
    setItemTransactionPage: (
      state: ProductItemStore,
      action: PayloadAction<number>
    ) => {
      state.productTransaction.pageIndex = action.payload;
    },
  },
});

export const {
  setProductItemDetailsData,
  setProductItemTransactionData,
  setItemTransactionPage,
} = slice.actions;
export const reducer = slice.reducer;

export const getProductItemDetails =
  (barcode: string): AsyncAppThunk =>
  async (dispatch) => {
    dispatch(
      showLoaderWhile(async () => {
        const apiResponse = await getProductItemByBarcodeService(barcode);
        if (
          apiResponse &&
          Object.keys(apiResponse).length > 0 &&
          apiResponse.result !== null
        ) {
          dispatch(setProductItemDetailsData(apiResponse.result));
        }
      })
    );
  };
export const getProductItemTransactions =
  (barcode: string): AsyncAppThunk =>
  async (dispatch, store) => {
    dispatch(
      showLoaderWhile(async () => {
        var productTransactionsPaging = store().productitems.productTransaction;
        var queryOptions = getFilterQuery(
          {},
          productTransactionsPaging.pageIndex *
            productTransactionsPaging.pageSize,
          productTransactionsPaging.pageSize
        );
        const apiResponse = await getProductItemTransactionByBarcodeService(
          barcode,
          queryOptions
        );
        if (
          apiResponse &&
          Object.keys(apiResponse).length > 0 &&
          apiResponse.result !== null
        ) {
          dispatch(setProductItemTransactionData(apiResponse.result));
        }
      })
    );
  };
